// extracted by mini-css-extract-plugin
export default {"page":"HI","top_block":"II","heading":"JI","inner_text":"KI","starter_text":"LI","starter_cta":"MI","summary_block":"NI","cartsummary_wrap":"OI","price":"PI","pricing_wrap":"QI","summary_block_mob":"RI","summary":"SI","pricing_heading":"TI","products_summary":"UI","summary_line":"VI","summary_price":"WI","summary_title":"XI"};
    if(module.hot) {
      // 1730991508619
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  